import { sendTrackingEvent, getSlideshowId, getPageKey } from "./base-tracker"
import { getFlagValue } from "app/assets/javascripts/utils/ab_tests"

const logPageKey = async () => {
  const isFeatureFlagActive = await getFlagValue("frontend_page_view_events")
  if (isFeatureFlagActive) {
    sendTrackingEvent("frontend_page_view_event_stream", {
      path: window.location.pathname,
      slideshow_id: getSlideshowId(),
      page_key: getPageKey(),
      referrer: document.referrer,
    })
  }
}

logPageKey()
